import React from "react";
import HappinessCounter from "./HappinessCounter";
import styles from "./Counter.styles";

function Counter() {
  return (
    <div style={styles.container}>
      <HappinessCounter />
    </div>
  );
}

export default Counter;
